<img
  class="w-100 aspect-4-3 carousel-height"
  [src]="headerImageNews(image.fullPath)"
  [alt]="news?.caption | langSelector"
  [title]="news?.caption | langSelector"
/>
<figcaption class="ml-2" style="font-size: 14px;text-align: center;">
  {{ news?.caption | langSelector }}
</figcaption>
